import React from 'react';
import './EmptyView.css';

interface EmptyViewProps {
  message: string;
}

const EmptyView: React.FC<EmptyViewProps> = ({ message }) => {
  return (
    <div className="empty-view">
      <p>{message}</p>
    </div>
  );
};

export default EmptyView; 